<template>
    <div class="lang-cnt">
      <a :href="opensaludLink" target="_blank">OPENSALUD</a>
      <a v-if="!inMx" :href="opensaludMxLink">OPENSALUD MEXICO</a>
      <a v-else :href="opensaludEsLink">OPENSALUD ESPAÑA</a>
      <a href="https://menttum.com" target="_blank" v-if="!inMx">MENTTUM</a>
      <!-- <a :href="$helpers.getV2AppUrl('opensaludprime')" target="_blank" v-if="!inMx">OPENSALUD PRIME</a> -->
      <a :href="$helpers.get360AppUrl()" target="_blank">OPENSALUD360</a>
      <!-- <a :href="$helpers.getV2AppUrl('opensalud4all')" target="_blank" v-if="!inMx">OPENSALUD4ALL</a> -->
      <!-- <a href="https://www.openlegal.es" target="_blank" v-if="!inMx">OPENLEGAL</a> -->
    </div>
</template>
  
<script>
import { ES_COUNTRY, MX_COUNTRY } from '@/constants/countries'
import { ES_LOCALE, MX_LOCALE } from '@/constants/locales'
import { inMx } from '@/helpers/global.helpers'

export default {
  name: 'GroupLinks',
	data () {
		return {
			inMx
		}
	},
  computed: {
    opensaludLink () {
      return this.$helpers.getV2AppUrl(`?langpref=${inMx ? MX_COUNTRY : ES_COUNTRY}${this.$i18n.locale}`)
    },
    opensaludEsLink () {
      return this.$helpers.getV2AppUrl(`?langpref=${ES_COUNTRY}${this.$i18n.locale === MX_LOCALE ? ES_LOCALE : this.$i18n.locale}`, true, false)
    },
    opensaludMxLink () {
      return this.$helpers.getV2AppUrl(`?langpref=${MX_COUNTRY}${this.$i18n.locale === ES_LOCALE ? MX_LOCALE : this.$i18n.locale}`, false, true)
    }
  }
}
</script>

<style lang="scss" scoped>
.lang-cnt {
    color: $white;
    display: block;
    transition: all 0.3s ease;

    span:not(.separator), a {
				@include overline-typescale;
        cursor: pointer;
        color: white;

        &:not(.country-label) {
            &:hover {
                text-decoration: underline;
            } 
        }

        &.country-label {
            cursor: initial;
        }

        &:not(:last-child) {
            margin-right: 2rem;
        }

        &.active {
            border-top: 2px solid $blue;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/base/GroupLinks.vue